import * as React from 'react';

import { View, WBText } from '@/core';
import Wrapper from './Wrapper';
import styles from './style';
import { DeskType, FloorType } from '../../model';

const headerTimes = ['7:00', '9:00', '11:00', '13:00', '15:00', '17:00', '19:00'];

interface Props {
	item: FloorType;
	renderDeskLabel: (desk: DeskType) => React.ReactNode;
	renderDeskSlots: (desk: DeskType) => React.ReactNode;
}

export const Selector: React.FC<Props> = ({ item, renderDeskLabel, renderDeskSlots }) => {
	return (
		<Wrapper>
			<View style={styles.slotSelection}>
				<View style={styles.labelColumn}>
					<View style={styles.header}>
						{/* adds offset to the labelColumn to account for the 7:00 - 19:00 headers in the other column */}
					</View>
					{item.items && item.items.map(renderDeskLabel)}
				</View>
				<View style={styles.slotsColumn}>
					<View style={styles.header}>
						{headerTimes.map((time) => (
							<WBText style={styles.timeHeader} key={time}>
								{time}
							</WBText>
						))}
					</View>
					{item.items && item.items.map(renderDeskSlots)}
				</View>
			</View>
		</Wrapper>
	);
};
